
import { Appointment } from '@/types';

/**
 * Map Supabase appointment data to our app's Appointment type
 */
export const mapSupabaseAppointment = (appointment: any): Appointment => {
  return {
    id: appointment.id,
    doctorId: appointment.doctor_id,
    date: appointment.date,
    timeSlot: appointment.time_slot,
    patientName: appointment.patient?.full_name || "Unknown",
    patientEmail: appointment.patient?.email || "",
    patientPhone: appointment.patient?.phone || "",
    patientAddress: appointment.patient?.address || "",
    patientGender: appointment.patient?.gender || "",
    patientAge: appointment.patient?.age || 0,
    status: appointment.status || "confirmed",
    createdAt: appointment.created_at
  };
};

/**
 * Map appointment data to Supabase format
 */
export const mapToSupabaseAppointment = (
  doctorId: string | number, 
  patientId: string,
  date: string,
  timeSlot: string,
  status: string = 'confirmed'
) => {
  return {
    doctor_id: doctorId.toString(),
    patient_id: patientId,
    date: date,
    time_slot: timeSlot,
    status: status
  };
};
